import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InsightsService } from '../../../services/insights-service';
import { UtilService } from '../../../services/util-service';

@Component({
  selector: 'app-request-access-modal',
  templateUrl: './request-access-modal.component.html',
  styleUrls: ['./request-access-modal.component.scss'],
  standalone: false,
})
export class RequestAccessModalComponent {
  @Input() dashboardName: string;
  @Input() companyName: string;

  agreed = false;
  submitting = false;
  errorMessage: string | null = null;

  constructor(
    private activeModal: NgbActiveModal,
    private insightsService: InsightsService,
    private utilService: UtilService,
  ) {}

  /**
   * Handles the REQUEST ACCESS button click: calls the request-access API with
   * isFirstTimeRequest=false and dashboardNames=[dashboardName].
   * On success, closes this modal and opens the same thank-you BootstrapModal as the request-access page.
   */
  onConfirm() {
    if (!this.dashboardName?.trim()) {
      this.errorMessage = 'Dashboard name is required.';
      return;
    }
    this.submitting = true;
    this.errorMessage = null;
    const dashboardNames = [this.dashboardName.trim()];
    this.insightsService.requestAccess(false, dashboardNames).subscribe({
      next: () => {
        this.submitting = false;
        this.activeModal.close(true);
        this.insightsService.showRequestAccessSuccessModal();
      },
      error: () => {
        this.submitting = false;
        this.errorMessage = 'Failed to submit access request. Please try again.';
        this.utilService.showToastError(this.errorMessage);
      },
    });
  }

  onClose() {
    this.activeModal.dismiss();
  }
}
